import React, {Component} from 'react'
import {Switch, Route} from 'react-router'

import SkillVendorSearchAndList from './search/SkillVendorSearchAndList'
import SkillVendorEdit from './SkillVendorEdit'

class SkillVendorAdmin extends Component {
  render() {
    return (
      <Switch>
        <Route path={this.props.match.path} exact component={SkillVendorSearchAndList} />
        <Route path={`${this.props.match.path}/:id(\\d+)`} component={SkillVendorEdit} />
      </Switch>
    )
  }
}
export default SkillVendorAdmin